import { CommApiInstance } from "Utils/CommApiInstance";

const MembOtpRegChkApi = async () => {
    return await CommApiInstance.post(`memb/otp/reg_chk`,{
        apiBody:{

        },
    })
    .then((Resp) => Resp.data);
}
export default MembOtpRegChkApi;